import styled from "styled-components";
import { transparentize } from "polished";

import theme from "config/theme";

import StyledImage from "components/Image";

export const Wrapper = styled.div`
  padding-top: 280px;
  position: relative;
  height: 800px;

  @media (max-width: ${theme.size.tablet}) {
    height: 600px;
    padding-top: 240px;
  }

  @media (max-width: ${theme.size.mobile}) {
    height: 400px;
  }

  &::before {
    content: "";
    position: absolute;
    top: -280px;
    left: 0;
    width: 100%;
    height: calc(100% + 280px);
    z-index: -1;
    background: linear-gradient(
      to top,
      ${transparentize(0.7, theme.color.gray)} 20%,
      ${transparentize(0, theme.color.gray)} 60%
    );
  }
`;

export const Image = styled(StyledImage)`
  position: absolute;
  top: -350px;
  left: 50%;
  width: 100%;
  min-width: 1200px;
  z-index: -2;
  transform: translateX(-50%);
`;
